function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState } from 'react';
import { SaveButton } from '@rd-web-markets/shared/dist/util/buttons';
import { CloseButton } from '@rd-web-markets/shared/dist/util/buttons/CloseButton';
import { ProjectSelector } from '@rd-web-markets/shared/dist/claim_project_report/ProjectSelector';
import { SubsidiaryCompanySelector } from '@rd-web-markets/shared/dist/claim_project_report/SubsidiaryCompanySelector';
import { BusinessUnitSelector } from '@rd-web-markets/shared/dist/claim_project_report/BusinessUnitSelector';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { COST_REDUCTION_CATEGORIES } from './costReductionCategories';
const CostSectionRateReductionForm = _ref => {
  let {
    claim,
    formState,
    setFormState,
    onReductionCategoryChange,
    saveReductionRate,
    cancelReductionRate,
    isSaveDisabled,
    isEditing
  } = _ref;
  const [isCategoryToReduceSelectorVisible, setIsCategoryToReduceSelectorVisible] = useState(false);
  useEffect(() => {
    setIsCategoryToReduceSelectorVisible(false);
  }, [formState.reductionCategory]);
  const onCategoryToReduceChange = event => {
    setFormState(prevFormState => _objectSpread(_objectSpread({}, prevFormState), {}, {
      categoryToReduce: String(event.target.value)
    }));
  };
  const onCategoryToReduceSelect = instance => {
    const displayTextKeyByReductionCategory = {
      'UkSection::SubsidiaryCompany': 'name',
      BusinessUnit: 'name',
      CommercialProject: 'project_name',
      ClaimProjectReport: 'project_name'
    };
    const displayTextKey = displayTextKeyByReductionCategory[formState.reductionCategory];
    const selectedInstanceName = (instance === null || instance === void 0 ? void 0 : instance[displayTextKey]) || '';
    setFormState(prevFormState => _objectSpread(_objectSpread({}, prevFormState), {}, {
      categoryToReduce: String(instance.id),
      categoryToReduceName: selectedInstanceName
    }));
    setIsCategoryToReduceSelectorVisible(false);
  };
  const selectedInstanceId = Number.isNaN(Number(formState.categoryToReduce)) ? formState.categoryToReduce : Number(formState.categoryToReduce);
  const alreadySelectedInstances = formState.categoryToReduce ? [{
    id: selectedInstanceId
  }] : [];
  const categoryToReduceInputByReductionCategory = {
    ClaimGroup: /*#__PURE__*/React.createElement(Form.Control, {
      value: claim.claim_group.name,
      readOnly: true
    }),
    'UkSection::SubsidiaryCompany': /*#__PURE__*/React.createElement(Form.Control, {
      value: formState.categoryToReduceName || '',
      placeholder: "Select Entity",
      readOnly: true,
      disabled: isEditing,
      onFocus: () => !isEditing && setIsCategoryToReduceSelectorVisible(true)
    }),
    BusinessUnit: /*#__PURE__*/React.createElement(Form.Control, {
      value: formState.categoryToReduceName || '',
      placeholder: "Select Business Unit",
      readOnly: true,
      disabled: isEditing,
      onFocus: () => !isEditing && setIsCategoryToReduceSelectorVisible(true)
    }),
    CommercialProject: /*#__PURE__*/React.createElement(Form.Control, {
      value: formState.categoryToReduceName || '',
      placeholder: "Select Commercial Project",
      readOnly: true,
      disabled: isEditing,
      onFocus: () => !isEditing && setIsCategoryToReduceSelectorVisible(true)
    }),
    ClaimProjectReport: /*#__PURE__*/React.createElement(Form.Control, {
      value: formState.categoryToReduceName || '',
      placeholder: "Select Project",
      readOnly: true,
      disabled: isEditing,
      onFocus: () => !isEditing && setIsCategoryToReduceSelectorVisible(true)
    })
  };
  const categoryToReduceSelectorByReductionCategory = {
    'UkSection::SubsidiaryCompany': /*#__PURE__*/React.createElement(SubsidiaryCompanySelector, {
      companyId: claim.company.id,
      alreadySelectedInstances: alreadySelectedInstances,
      onChange: onCategoryToReduceChange,
      onBlur: onCategoryToReduceChange,
      onSelectInstance: onCategoryToReduceSelect,
      eventFieldName: "categoryToReduce"
    }),
    BusinessUnit: /*#__PURE__*/React.createElement(BusinessUnitSelector, {
      companyId: claim.company.id,
      alreadySelectedInstances: alreadySelectedInstances,
      onChange: onCategoryToReduceChange,
      onBlur: onCategoryToReduceChange,
      onSelectInstance: onCategoryToReduceSelect,
      eventFieldName: "categoryToReduce"
    }),
    CommercialProject: /*#__PURE__*/React.createElement(ProjectSelector, {
      claimGroupId: claim.claim_group.id,
      alreadySelectedInstances: alreadySelectedInstances,
      onChange: onCategoryToReduceChange,
      onBlur: onCategoryToReduceChange,
      onSelectInstance: onCategoryToReduceSelect,
      eventFieldName: "categoryToReduce"
    }),
    ClaimProjectReport: /*#__PURE__*/React.createElement(ProjectSelector, {
      claimGroupId: claim.claim_group.id,
      alreadySelectedInstances: alreadySelectedInstances,
      onChange: onCategoryToReduceChange,
      onBlur: onCategoryToReduceChange,
      onSelectInstance: onCategoryToReduceSelect,
      eventFieldName: "categoryToReduce"
    })
  };
  return /*#__PURE__*/React.createElement(Card, {
    className: "mb-4 border-dark"
  }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Row, {
    className: "g-3 align-items-end"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(Form.Group, {
    controlId: "cost-section-rate-reduction-category"
  }, /*#__PURE__*/React.createElement(Form.Label, null, "Select Reduction Category"), /*#__PURE__*/React.createElement(Form.Select, {
    value: formState.reductionCategory,
    onChange: onReductionCategoryChange,
    disabled: isEditing
  }, COST_REDUCTION_CATEGORIES.map(reductionCategory => /*#__PURE__*/React.createElement("option", {
    key: reductionCategory.value,
    value: reductionCategory.value
  }, reductionCategory.label))))), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(Form.Group, {
    controlId: "cost-section-rate-reduction-category-to-reduce"
  }, /*#__PURE__*/React.createElement(Form.Label, null, "Select Category To Reduce"), categoryToReduceInputByReductionCategory[formState.reductionCategory], isCategoryToReduceSelectorVisible && categoryToReduceSelectorByReductionCategory[formState.reductionCategory])), /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement(Form.Group, {
    controlId: "cost-section-rate-reduction-rate"
  }, /*#__PURE__*/React.createElement(Form.Label, null, "Enter Reduction Rate (for 10% enter 10)"), /*#__PURE__*/React.createElement(Form.Control, {
    type: "number",
    step: "0.1",
    value: formState.reductionRate,
    onChange: event => setFormState(_objectSpread(_objectSpread({}, formState), {}, {
      reductionRate: event.target.value
    }))
  }))), /*#__PURE__*/React.createElement(Col, {
    md: 1,
    className: "d-flex gap-2"
  }, /*#__PURE__*/React.createElement(SaveButton, {
    variant: "link",
    className: "p-0",
    onClick: saveReductionRate,
    disabled: isSaveDisabled,
    text: "",
    type: "button",
    "aria-label": "Save rate reduction"
  }), /*#__PURE__*/React.createElement(CloseButton, {
    variant: "link",
    className: "p-0",
    onClick: cancelReductionRate,
    type: "button",
    "aria-label": "Cancel rate reduction"
  })))));
};
export default CostSectionRateReductionForm;